import { useQuery } from '@pylot-data/hooks/use-query'
import type {
    CategoryTree,
    CategoryResult,
    Maybe
} from '@pylot-data/pylotschema'
import type { SWRConfiguration } from 'swr'
import { RequestInit } from '@vercel/fetch'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { navigationMenuWithCMSBlocks } from './graphql/navigationMenuWithCMSBlocks'
import { MenuPreloadVariables } from '@preload/graphql/getConfig.d'

export type NavigationResponse = {
    navigation?: Maybe<CategoryTree>
    isValidating: boolean
    error?: GraphQLError
}

export const useNavMenu = (
    variables?: Maybe<MenuPreloadVariables>,
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
): NavigationResponse => {
    const { data, error, isValidating } = useQuery<
        Maybe<MenuPreloadVariables>,
        { categories: CategoryResult }
    >(navigationMenuWithCMSBlocks, variables, swrOptions, fetchOptions)
    const categories = data?.data?.categories?.items ?? []
    const category = categories[0] as CategoryTree
    if (categories[0]?.children) {
        category.children = category.children?.filter(
            (i) => !!i?.include_in_menu
        )
    }
    const filterCategoriesRecursively: (category: CategoryTree) => any = (
        category: CategoryTree
    ) => {
        const filteredChildren = category.children
            ?.filter((child) => child?.include_in_menu === 1)
            .map((child) => filterCategoriesRecursively(child!))

        return { ...category, children: filteredChildren }
    }

    return {
        navigation: categories.map((category) =>
            filterCategoriesRecursively(category as CategoryTree)
        )?.[0],
        isValidating,
        error
    }
}
